// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".incentive-root .custom-nav-block[data-v-156ad321]{background-color:transparent}", ""]);
// Exports
module.exports = exports;
